import React from 'react';
export default function getElement(getNode) {
    return () => React.createElement(React.Fragment, null, getNode());
}
